import JobPanelList from "@spa/features/search_job/pc/components/list/JobPanelList";
import JobAlert from "@spa/features/search_job/pc/components/list/JobAlert";
import RelatedKeywordList from "@spa/features/search_job/pc/components/related_keyword/RelatedKeywordList";
import {Pagination} from "@spa/features/search_job/pc/components/list/Pagination";

const JobList = ({
    searchResultViewModel,
    savedJobsForSearchResult,
    handleSaveJob,
}) => {
    return (
        <div className="l-c-left">
            <p className="p-result_num">{searchResultViewModel.hitCountDisplay}</p>
            <ul>
                <JobPanelList
                    searchResultViewModel={searchResultViewModel}
                    savedJobsForSearchResult={savedJobsForSearchResult}
                    handleSaveJob={handleSaveJob}
                />
            </ul>
            <Pagination
                hasPreviousPage={searchResultViewModel.hasPreviousPage}
                previousPageUrl={searchResultViewModel.previousPageUrl}
                hasNextPage={searchResultViewModel.hasNextPage}
                nextPageUrl={searchResultViewModel.nextPageUrl}
                pageCountDisplay={searchResultViewModel.pageCountDisplay}
                translations={searchResultViewModel.translations.pagination}
            />
            <RelatedKeywordList searchResultViewModel={searchResultViewModel} />
            {searchResultViewModel.isDisplayJobAlert && <JobAlert translations={searchResultViewModel.translations} />}
        </div>
    );
}

export default JobList;
